module.exports = __webpack_public_path__ + "media/efdab_1.1g.f20fe431.mp3";